import React from "react";
import Button from "./Button";

const SubmitFormButton = ({loading, text}) => {

    return <Button type='submit' text={text} loading={loading}/>

}

export default SubmitFormButton;